
import { createContext, useContext, useEffect, useState } from "react";
import { loginApi } from "../api/authApi";
import { setToken, getToken, removeToken } from "../utils/token";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ FIX: define logout BEFORE useEffect
  const logout = () => {
    removeToken();
    setUser(null);
  };

  // ✅ Load user on refresh
  useEffect(() => {
    const token = getToken();

    if (token) {
      try {
        const decoded = jwtDecode(token);

        // ✅ expiry check
        if (decoded.exp * 1000 < Date.now()) {
          logout();
        } else {
          setUser(decoded);
        }
      } catch (err) {
        logout();
      }
    }

    setLoading(false);
  }, []);

  // ✅ login
  const login = async (data) => {
    const res = await loginApi(data);

    setToken(res.accessToken);

    let decoded;
    try {
      decoded = jwtDecode(res.accessToken);
    } catch (err) {
      console.warn("JWT decode failed, using user payload fallback", err);
      decoded = res.user || null;
    }

    if (decoded) {
      setUser(decoded);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
